import Button from 'components/ReusableComponents/Button'
import PromotionIcon from 'features/Widgets/WidgetsCard/PromotionIcon'
import { useHistory, useLocation } from 'react-router-dom'

import styles from './DripCountIndicator.module.scss'

const DripCountIndicator = ({
  dripCount,
  isDefaultCampaigns,
  setIsCreateNewCampaignDialogVisible
}) => {
  const location = useLocation()
  const history = useHistory()

  const inviteMessagesRoute = `/${
    isDefaultCampaigns ? 'defaultCampaigns' : 'manageCampaigns'
  }/sales`
  const dripCampaignsRoute = '/custom-campaigns'

  const inviteMessagesLocation =
    location.pathname + location.search === inviteMessagesRoute
  const dripCampaignsLocation = location.pathname + location.search === dripCampaignsRoute

  const handleClick = () => {
    if (inviteMessagesLocation && !isDefaultCampaigns) {
      history.push('/custom-campaigns')
    }
    if (dripCampaignsLocation) {
      setIsCreateNewCampaignDialogVisible(true)
    }
  }

  return (
    <div className={styles.dripCountContainer}>
      <div className={styles.dripCountIndicator}>
        <PromotionIcon withoutCircle={true} />
        You have {dripCount || 'no'} complimentary texts available for a drip campaign or
        an announcement.
      </div>
      <Button
        className={styles.campaignButton}
        type="secondary"
        size="small"
        onClick={handleClick}
      >
        Create a drip campaign
      </Button>
    </div>
  )
}

export default DripCountIndicator
